import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';

export const cartelerasdApi = createApi({
  reducerPath: 'cartelerasdApi',
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_CHECKOUT_API_TEST}/checkout-billboards/api/v1`,
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  tagTypes: ['Carteleras', 'CartelerasEvents'],
  keepUnusedDataFor: 30,
  endpoints: (build) => ({
    getBillboardByIdOrName: build.query({
      query: (value) => `billboard/${value}`,
      providesTags: ['Carteleras'],
      keepUnusedDataFor: 0,
    }),
    getBillboardsEvents: build.query({
      query: (value) => `billboard/events/${value}`,
      providesTags: ['CartelerasEvents'],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetBillboardByIdOrNameQuery,
  useLazyGetBillboardByIdOrNameQuery,
  useGetBillboardsEventsQuery,
  useLazyGetBillboardsEventsQuery,
  util: { getRunningQueriesThunk },
} = cartelerasdApi;

export const { getBillboardByIdOrName } = cartelerasdApi.endpoints;